import { render, staticRenderFns } from "./SpeakerNotesPanel.vue?vue&type=template&id=3ada2066&scoped=true"
import script from "./SpeakerNotesPanel.vue?vue&type=script&lang=js"
export * from "./SpeakerNotesPanel.vue?vue&type=script&lang=js"
import style0 from "./SpeakerNotesPanel.vue?vue&type=style&index=0&id=3ada2066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ada2066",
  null
  
)

export default component.exports